import React from 'react';
import { MuiBox } from 'theme/material-ui';
import { FontSize } from 'modules/styles/variables';
import { Svg } from 'components/UI/Svg';
import { Box } from '@material-ui/core';
import Typography from 'components/UI/Typography';
import { useHistory } from 'react-router';
import StyledButton from 'components/UI/Button/StyledButton';

const LoggedOut = () => {
  const history = useHistory();
  const onConfirm = () => {
    history.push('/landing');
  };

  const wordMyHealth = 'My Health+';

  return (
    <MuiBox flexDirection="row" alignContent="center" justifyContent="center">
      <Box display="flex" justifyContent="center">
        <Svg name="Intermountain" size={292} />
      </Box>

      <Box margin={1}>
        <Typography fontSize={FontSize.large} textAlign="center">
          You are now logged out.
        </Typography>
      </Box>
      <Box p={4}>
        <Typography fontSize={FontSize.large} textAlign="center">
          To continue completing the pre-visit checklist, please click the link in the text message
          you received or click the button below to go to the My Health+ page.
        </Typography>
      </Box>
      <Box mt={10} p={4}>
        <StyledButton
          style={{ height: 40, display: 'flex', margin: '0 auto' }}
          textStyle={{ fontSize: FontSize.small }}
          onPress={onConfirm}
        >
          Go to {wordMyHealth}
        </StyledButton>
      </Box>
    </MuiBox>
  );
};
export default LoggedOut;
